/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import { Fragment, useEffect, useState, useMemo } from "react";
import PropTypes from 'prop-types';
import { InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Paper, Box, Grid, Button } from "@mui/material";

import { useLayout } from "../../context/System/LayoutContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { esES } from "@mui/material/locale";
import getObjectValue from "lodash.get";
import { isNullOrEmpty } from "../../settings/utils";
import SearchIcon from "@mui/icons-material/Search";

export default function SizeSoftXTableCatalogos(props) {
    const {SubRow, data, columns, fnDoubleClick, disableStickyHeader, totalDeRegistros, setRow, defaultRow, row, id, task, pagModel, setPagModel } = props;
    const pager = [3, 4, 5, 6, 9, 10, 15, 20, 50, 100];
    const theme = createTheme(esES);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pager[0]);
    const [dataRows, setDataRows] = useState(data);
    const [filters, setFilters] = useState({});
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState(true);
    const [modelLocal, setModelLocal] = useState(pagModel);
 
    const { tablaReferencia } = useLayout();

    const {
        setPaginadoModel,
        getPaginadoModel,
        paginadoModel
    } = useConfiguracion();

    const handleChangePage = async (e, page) => {
        // Usar llamado de paginado al API
        const nuevoPaginador = {
            ...pagModel,
            numPag: { value: page + 1 },
            numReg: { value: rowsPerPage },
        };

        if (setPagModel) {
            setPagModel(nuevoPaginador);
        }
        paginadoModel.pagina.value = page + 1;
        setPage(page);
    };

    const handleChangeRowsPerPage = async (e) => {
        paginadoModel.registroPorPagina.value = parseInt(e.target.value);
        paginadoModel.pagina.value = 1;
        setRowsPerPage(parseInt(e.target.value));

        const nuevoPaginador = {
            ...pagModel,
            numPag: { value: page + 1 },
            numReg: { value: parseInt(e.target.value) },
        };

        if (setPagModel) {
            setPagModel(nuevoPaginador);       
        }
        setPage(0);
    };

    const handleClickRow = (valueRow) => () => {
        if (!defaultRow) {
            setRow(valueRow);
            return;
        }

        if (!row) {
            setRow(valueRow);
            return;
        }

        if (valueRow[id] === row[id]) {
            setRow(defaultRow);
            return;
        }

        setRow(valueRow);
    };

    const handleClickOrder = (field, param=false) => {
        //const orderField = field === orderBy ? order : order;
        const orderField = field === orderBy ? (param?order:!order) : order;

        const nuevoPaginador = {
            ...pagModel,
            ByOrder: { value: orderField === false ? "Desc" : "Asc" },
            OrderProperty: { value: field },
        };

        if (setPagModel) {
            setPagModel(nuevoPaginador); 
        }

        const orderList = handleGetListOrden(dataRows, field,orderField);

        setDataRows(orderList);

        /*if (field === orderBy) {
            setOrder(orderField);
            return;
        }

        setOrderBy(field);*/

        setOrder(orderField);
   
        if(!isNullOrEmpty(field)){
            setOrderBy(field);
        }
    };

    const handleGetListOrden=(dataList,fieldFilter,orderField)=>{
        const orderList = orderField
        ? dataList.sort((a, b) => {
              const valueA = getObjectValue(a, fieldFilter);
              const valueB = getObjectValue(b, fieldFilter);
              // return a[field as U] < b[field as U] ? -1 : a[field as U] > b[field as U] ? 1 : 0
              //return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              if( typeof valueA === 'string' && typeof valueB === 'string'){
                return valueA.toLowerCase() < valueB.toLowerCase() ? -1 : valueA.toLowerCase() > valueB.toLowerCase() ? 1 : 0;
              }
              else{
                return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              }
          })
        : dataList.sort((a, b) => {
              const valueA = getObjectValue(a, fieldFilter);
              const valueB = getObjectValue(b, fieldFilter);
              // return a[field as U] < b[field as U] ? 1 : a[field as U] > b[field as U] ? -1 : 0
              //return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
              if( typeof valueA === 'string' && typeof valueB === 'string'){
                return valueA.toLowerCase() < valueB.toLowerCase() ? 1 : valueA.toLowerCase() > valueB.toLowerCase() ? -1 : 0;
              } 
              else{
                return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
              }
          });
        return orderList;
    }

    //Capturar al escribir en los filtros
    const handleChangeFilter = (e) => {
        setFilters({
            ...filters,
            [e.target.name]: e.target.value,
        });

        const newModel = {
            ...modelLocal,
            numReg:{value: rowsPerPage},
            numPag:{value: 1},
            [e.target.name]: {value:e.target.value},
        };
        setModelLocal(newModel);
        setPage(0);  
    };
    
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') 
        {
            if (setPagModel) {
                setPagModel(modelLocal);
            }
        }
    };

    //Crear objecto de filtro
    useEffect(() => {
        const filterObj = {};

        columns.forEach((column) => {
            filterObj[column.field] = "";
        });

        setFilters(filterObj);
        // eslint-disable-next-line
    }, []);

    //Filtrar al escribir
    useEffect(() => {
        const keys = Object.keys(filters);
        const values = Object.values(filters);

        if (keys.length <= 0) {
            return;
        }

        if (values.every((x) => x === "")) {
            setDataRows(data);
            return;
        }

        let filterList = [...data];
        keys.forEach((key, i) => {
            const filterText = values[i].trim().toUpperCase();

            if (filterText === "") {
                return;
            }

            filterList = filterList.filter((x) => {
                const valueKey = getObjectValue(x, key, null);
                // return !x[key as U] ? false : x[key as U].toString().toUpperCase().includes(filterText);
                return !valueKey ? false : valueKey.toString().toUpperCase().includes(filterText);
            });
        });

        setDataRows(filterList);
        // eslint-disable-next-line
    }, [filters]);

    //Actualizar datos originales
    useEffect(() => {
        setDataRows(data);
        const filterObj = { ...filters };
        const keys = Object.keys(filterObj);

        /*if (keys.length > 0) {
            keys.forEach((key) => {
                filterObj[key] = "";
            });
        }*/

        setFilters(filterObj);
    }, [data]);    

    useEffect(() => {
        setDataRows(data);
    }, [data]);

    // useEffect(() => {
    //     if(orderBy){
    //         handleChangePageClickOrder(orderBy,true);
    //     }
    // }, [data]);

    return (
        <Fragment>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                <Grid item xs={12}>
                    <TableContainer
                        //sx={{ maxHeight: !disableStickyHeader ? "calc(100vh - 160px)" : "initial" }}
                        component={Paper}
                    >
                        <Table
                            size="small"
                            ref={tablaReferencia}                        
                            stickyHeader={!disableStickyHeader}
                            className="SizeSoftX-table"
                        >
                            <TableHead>
                                <TableRow>
                                    {SubRow && <TableCell></TableCell>}
                                    {columns.map((column, i) => (
                                            <TableCell
                                                key={i}
                                                style={{
                                                    minWidth: !column.width ? "initial" : column.width,
                                                    verticalAlign: "top",
                                                }}
                                            >                                    
                                            {!column.hideSort && (
                                                <Button
                                                    style={{
                                                        textOverflow: "ellipsis",
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textTransform: "none",
                                                        fontSize: "large",
                                                    }}
                                                    variant="text"
                                                    color="inherit"
                                                    className={orderBy === column.field ? "sort" : "no-sort"}
                                                    onClick={() => handleClickOrder(column.field)}
                                                    startIcon={
                                                    orderBy === column.field ? (
                                                        order ? (
                                                        <ArrowUpwardIcon />
                                                        ) : (
                                                        <ArrowDownwardIcon />
                                                        )
                                                    ) : (
                                                        <ArrowUpwardIcon />
                                                    )
                                                    }
                                                >
                                                    <Typography color="secondary" variant="button" sx={{ fontWeight: "600" }}>
                                                        {column.title}
                                                    </Typography>
                                                </Button>
                                            )}
                                            {!column.hideFilter && (
                                                <TextField
                                                    onKeyDown={handleKeyPress}
                                                    name={column.field}
                                                    placeholder={"Buscar" /*+ column.title + "..."*/}
                                                    onChange={handleChangeFilter}
                                                    autoComplete="off"
                                                    value={!filters[column.field] ? "" : filters[column.field]}
                                                    size="small"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <SearchIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                            {column.showRenderHeader && column.renderHeader()}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataRows.length > 0 ? (
                                    dataRows.map((dataRow, i) => (
                                        <TableRow 
                                            style={{height:55}}
                                            key={i} 
                                            onClick={handleClickRow(dataRow)}
                                            onDoubleClick={!fnDoubleClick ? () => {} : fnDoubleClick}
                                            className={!row ? "no-row" : dataRow[id] === row[id] ? "row" : "no-row"}
                                        >

                                            {columns.map((column, j) => (
                                                <TableCell  key={j} align={!column.align ? "left" : column.align}>
                                                    {!column.render ? <Typography >{dataRow[column["field"]]}</Typography> : column.render(dataRow)}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={columns.length} align="center">
                                            <Typography>No se encontraron registros para mostrar</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <Box display="flex" justifyContent="center">
                            {totalDeRegistros > 0 && (
                                <TablePagination
                                    component="div"
                                    count={totalDeRegistros}
                                    //page={page}
                                    page={paginadoModel.reiniciarPagina.value === true ? 0 : page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    rowsPerPageOptions={pager}
                                    labelRowsPerPage="Registros por pégina"
                                />
                            )}
                        </Box>
                    </TableContainer>
                </Grid>
            </Grid>
        </Fragment>
    );
}

SizeSoftXTableCatalogos.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            field: PropTypes.string,
            title: PropTypes.string,
            render: PropTypes.func,
            hideSort: PropTypes.bool,
            width: PropTypes.number,
            align: PropTypes.string,
            renderHeader: PropTypes.func,
        })
    ),
    countRegistros: PropTypes.number,
    totalDePaginas: PropTypes.number,
    data: PropTypes.array,
    fnDoubleClick: PropTypes.func,
    disableStickyHeader: PropTypes.bool,
};